/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing system report summary components.
 * @preferred
 * @module SystemReportSummaryModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';
import { AviCardModule } from 'nsx-alb-ui-components';
import { CommonModule } from '@angular/common';
import { LetModule } from '@ngrx/component';
import { VIPModule } from '@vmw/ngx-vip';

import {
    ClrAccordionModule,
    ClrProgressBarModule,
    ClrSpinnerModule,
} from '@clr/angular';

import { CoreModule } from 'ng/modules/core/core.module';

import {
    SystemReportSummaryCardComponent,
    SystemReportSummaryCardProgressBarComponent,
} from './components';

import {
    SecondToMsPipe,
} from './pipes';

const components = [
    SystemReportSummaryCardComponent,
    SystemReportSummaryCardProgressBarComponent,
];

const pipes = [
    SecondToMsPipe,
];

@NgModule({
    declarations: [
        ...components,
        ...pipes,
    ],
    exports: [
        SystemReportSummaryCardComponent,
        ...pipes,
    ],
    imports: [
        AviCardModule,
        ClrAccordionModule,
        ClrProgressBarModule,
        ClrSpinnerModule,
        CommonModule,
        CoreModule,
        LetModule,
        VIPModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SystemReportSummaryModule { }
